import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { SideMenuItemModel } from '../core/models/sidemenu.model';

import { HomeService } from './service/home.service';
import { FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { WidgetModel, WidgetInfoModel, InformationModel } from '../core/models/widget.model';
import {SidemenuDragAndDropService } from 'lps-navigation';
import { AuthTokenService } from '../core/services/auth-token/auth-token.service';
import { FeatureToggleService } from '../core/toggle/feature-toggle.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  isManager = false;

  constructor(
    private authTokenService: AuthTokenService,
    private featureToggleService: FeatureToggleService,
  ) { }

  ngOnInit(): void {
    this.isManager = this.featureToggleService.isActive('toggle_manager_vision') && this.authTokenService.isManager();
  }
}
